export default class CookingView {
    constructor($el) {
        this.$el = $el;
        this.$content = this.$el.querySelector('[data-content]');
        this.$contentContainer = this.$el.querySelector('[data-content-container]');
        this.$toggleRecipe = this.$el.querySelector('[data-toggle-recipe]');
        this.$toggleContent = this.$el.querySelector('[data-toggle-content]');
        this.$ingredientsView = this.$el.querySelector('[data-cooking-view-ingredients]');
        this.$mainView = this.$el.querySelector('[data-cooking-view-main]');
        this.$buttonPrevStep = this.$el.querySelector('[data-prev-step]');
        this.$buttonNextStep = this.$el.querySelector('[data-next-step]');
        this.$steps = this.$el.querySelectorAll('[data-step]');
        this.wakeLock = null;

        this.calculateProgress = this.calculateProgress.bind(this);
        this.toggleView = this.toggleView.bind(this);
        this.scrollToPrevStep = this.scrollToPrevStep.bind(this);
        this.scrollToNextStep = this.scrollToNextStep.bind(this);

        this.$contentContainer.addEventListener('scroll', this.calculateProgress);
        this.$toggleRecipe.addEventListener('click', this.toggleView);
        this.$toggleContent.addEventListener('click', this.toggleView);
        this.$buttonPrevStep.addEventListener('click', this.scrollToPrevStep);
        this.$buttonNextStep.addEventListener('click', this.scrollToNextStep);


        document.addEventListener("visibilitychange", this.initWakeLock);


        this.calculateProgress();

        this.initWakeLock();
    }

    /**
     * Calculate the scroll progress
     */
    calculateProgress() {
        const percentage = Math.ceil((this.$contentContainer.scrollTop / (this.$contentContainer.scrollHeight  - this.$contentContainer.offsetHeight)) * 100);

        this.$content.style.setProperty('--recipe-cooking-view-progress', percentage + '%');
    }

    /**
     * Toggle between the ingredient and the recipe view (only for breakpoints smaller then lg)
     * @param e
     */
    toggleView(e) {
        e.preventDefault();

        this.$toggleRecipe.classList.toggle('tab-button--active');
        this.$toggleContent.classList.toggle('tab-button--active');

        this.$ingredientsView.classList.toggle('recipe-cooking-view__ingredients--active');
        this.$mainView.classList.toggle('recipe-cooking-view__main--active');
    }

    /**
     * Scroll to prev step
     * 
     * @param e
     */
    scrollToPrevStep(e) {
        e.preventDefault();
        const $activeStep = this.getActiveStep();
        const prevStepNumber = parseInt($activeStep.dataset.stepNumber) - 1;
        const topPadding = parseInt(window.getComputedStyle(this.$contentContainer).getPropertyValue('padding-top'));

        if (prevStepNumber <= 0) {
            return;
        }

        const $prevStep = this.$el.querySelector('[data-step-number="' + prevStepNumber + '"]');
        const top = this.$contentContainer.scrollTop + ($prevStep.getBoundingClientRect().top - this.$contentContainer.getBoundingClientRect().top) - topPadding;

        this.$contentContainer.scrollTo({
            top: top,
            behavior: "smooth"
        });
    }

    /**
     * Scroll to the next step
     *
     * @param e
     */
    scrollToNextStep(e) {
        e.preventDefault();
        const $activeStep = this.getActiveStep();
        const nextStepNumber = parseInt($activeStep.dataset.stepNumber) + 1;
        const topPadding = parseInt(window.getComputedStyle(this.$contentContainer).getPropertyValue('padding-top'));

        if (nextStepNumber > this.$steps.length) {
            return;
        }

        const $nextStep = this.$el.querySelector('[data-step-number="' + nextStepNumber + '"]');
        const top = this.$contentContainer.scrollTop + ($nextStep.getBoundingClientRect().top - this.$contentContainer.getBoundingClientRect().top) - topPadding;

        this.$contentContainer.scrollTo({
            top: top,
            behavior: "smooth"
        });
    }

    /**
     * Determine the active step based on the steps position
     * @return {null}
     */
    getActiveStep() {// Get container bounds
        const containerRect = this.$contentContainer.getBoundingClientRect();
        const centerY = containerRect.top + (containerRect.height / 3);

        let activeStep = null;
        let minDistance = Infinity;

        this.$steps.forEach($step => {
            const rect = $step.getBoundingClientRect();
            const stepCenterY = rect.top + (rect.height / 2);
            const distance = Math.abs(stepCenterY - centerY);

            if (distance < minDistance) {
                minDistance = distance;
                activeStep = $step;
            }
        });

        return activeStep;
    }

    async initWakeLock() {
        if ( ! "wakeLock" in navigator) {
            console.debug('Wake lock is not supported by this browser.');
            return;
        }

        // create an async function to request a wake lock
        try {
            this.wakeLock = await navigator.wakeLock.request("screen");
        } catch (err) {
            console.error(`${err.name}, ${err.message}`);
        }
    }
}